/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SessionSupportStatus {
  nosupport = 0,
  supportrequested = 1,
  supportconnected = 2,
}
